import { LanguageCode } from './enums/languageCode.enum';

export function getLanguageCode(
  langString: string | undefined | null,
): LanguageCode {
  if (!langString) return LanguageCode.FR;

  const languageCode = langString.split(',')[0];
  switch (languageCode) {
    case 'fr':
      return LanguageCode.FR;
    case 'en':
      return LanguageCode.EN;
    default:
      return LanguageCode.FR;
  }
}

export function formatTriggerDateToIsoString(dateString: string): string {
  const chunks = dateString.split('/');
  const chunkDay = parseInt(chunks[0], 10);
  const chunkMonth = parseInt(chunks[1], 10);
  const year = parseInt(chunks[2], 10);
  const day =
    chunkDay.toString().length > 1 ? chunkDay.toString() : `0${chunkDay}`;
  const month =
    chunkMonth.toString().length > 1 ? chunkMonth.toString() : `0${chunkMonth}`;
  return `${year}-${month}-${day}T00:00:00.000+00:00`;
}

export function isValidHourFormat(hour: string): boolean {
  const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
  return regex.test(hour);
}

export function isValidISOString(dateString: string): boolean {
  const isoDateRegex =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}\+\d{2}:\d{2}$/;
  return isoDateRegex.test(dateString);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNotNullOrUndefined(valeur: any): boolean {
  return valeur !== null && valeur !== undefined;
}

export function isEmpty(value: string | undefined): boolean {
  return value === '';
}

export function isNullOrEmptyArray<T>(array: T[]): boolean {
  return isNotNullOrUndefined(array) && array.length === 0;
}

export function trimSpaces(inputText: string): string {
  return inputText.trim();
}

export function parseStringToArrayOfString(
  value: string,
  separateur: string,
): string[] {
  return value ? value.split(separateur).map((item) => item.trim()) : [];
}

export function checkEnumValue<T extends Record<string, string>>(
  value: string,
  enumObj: T,
): boolean {
  return Object.values(enumObj).includes(value);
}

export function checkEnumValues<T extends Record<string, string>>(
  values: string[],
  enumObj: T,
): boolean {
  return values.every((value) => Object.values(enumObj).includes(value));
}

/**
 * Permet de comparer deux tableaux de mêmes types.
 * @param arr1
 * @param arr2
 * @returns
 */
export function areArraysDifferent<T>(arr1: T[], arr2: T[]): boolean {
  if (arr1.length !== arr2.length) {
    return true;
  }

  const map1 = new Map<T, number>();
  const map2 = new Map<T, number>();

  arr1.map((item) => map1.set(item, (map1.get(item) || 0) + 1));
  arr2.map((item) => map2.set(item, (map2.get(item) || 0) + 1));
  let arraysAreDifferents = false;

  for (const [key, value] of map1.entries()) {
    if (map2.get(key) !== value) {
      arraysAreDifferents = true;
      break;
    }
  }
  return arraysAreDifferents;
}

export function removeNullOrUndefinedProperties<T>(obj: T): T {
  for (const key in obj) {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }
  return obj;
}

export function convertArray2DOnOneD<T>(array2D: T[][]): T[] {
  return array2D.reduce((accumulator, currentArray) => {
    currentArray.forEach((obj) => accumulator.push(obj));
    return accumulator;
  }, []);
}
export function replaceAllOccurrences(
  mainString: string,
  searchString: string,
  replacement: string,
): string {
  const regex = new RegExp(searchString, 'g');
  const modifiedString = mainString.replace(regex, replacement);
  return modifiedString;
}

export function getSubstringAfter(input: string, sub: string): string {
  const index = input.indexOf(sub);
  if (index === -1) {
    return '';
  }
  return input.substring(index + sub.length);
}

export const WEB_SOCKET_EVENT = {
  DOCUMENT_REQUEST: {
    EVENT_TO_LISTEN_LIST: 'documentRequest-event-list',
    SUBSCRIBE_MESSAGE_LIST: 'subscribe-documentRequest-event-list',
    EVENT_TO_LISTEN_DETAIL: 'documentRequest-event-detail',
    SUBSCRIBE_MESSAGE_DETAIL: 'subscribe-documentRequest-event-detail',
  },
  DOCUMENT_REQUEST_DETAIL: {
    EVENT_TO_LISTEN_LIST: 'documentRequestDetail-event-list',
    SUBSCRIBE_MESSAGE_LIST: 'subscribe-documentRequestDetail-event-list',
    EVENT_TO_LISTEN_SINGLE: 'documentRequestDetail-event-single',
    SUBSCRIBE_MESSAGE_SINGLE: 'subscribe-documentRequestDetail-event-single',
  },
  CONTRACT: {
    EVENT_TO_LISTEN_ADMIN: 'contract-event-admin',
    SUBSCRIBE_MESSAGE_ADMIN: 'subscribe-contract-event-admin',
    EVENT_TO_LISTEN_EMPLOYEE: 'contract-event-employee',
    SUBSCRIBE_MESSAGE_EMPLOYEE: 'subscribe-contract-event-employee',
    EVENT_TO_LISTEN_SINGLE: 'contract-event-single',
    SUBSCRIBE_MESSAGE_SINGLE: 'subscribe-contract-event-single',
  },
};

/* eslint-disable */
export function base64ToArrayBuffer(base64: string) {
  var binaryString = atob(base64);
  var bytes = new Uint8Array(binaryString.length);
  for (var i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}
/* eslint-enable */

export const MAX_BULK_DOWNLOAD_SIZE = 120;

export const EMPTY_VARIABLE_VALUE = '................';
